import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneSuccessStory = createAsyncThunk(
  "GetOneSuccessStory/GetOneSuccessStory",
  async (pR_successStoriesId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_successStories/GetPR_successStoriesData",
        {
          pR_successStoriesId: pR_successStoriesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "jojo");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteSuccessStory = createAsyncThunk(
  "DeleteSuccessStory/DeleteSuccessStory",
  async (pR_successStoriesId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_successStories/DeletePR_successStoriesData",
        {
          pR_successStoriesId: pR_successStoriesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListSuccessStory = createAsyncThunk(
  "GetListSuccessStory/GetListSuccessStory",
  async (pR_ReportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_successStories/GetPR_successStoriesListData",
        {
          pR_ReportsStagesGuid: pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateGetListSuccessStoryData = createAsyncThunk(
  "UpdateGetListSuccessStoryData/UpdateGetListSuccessStoryData",
  async (SuccessStoryData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_successStories/UpdatePR_successStoriesData",
        {
          pR_successStoriesId: SuccessStoryData.pR_successStoriesId,
          nameOfPersonConcerned: SuccessStoryData.nameOfPersonConcerned,
          successStoryDetails: SuccessStoryData.successStoryDetails,
          quotationsFromPersonConcerned:
            SuccessStoryData.quotationsFromPersonConcerned,
          pR_ReportsStagesGuid: SuccessStoryData.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddSuccessStoryData = createAsyncThunk(
  "AddSuccessStoryData/AddSuccessStoryData",
  async (SuccessStoryData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_successStories/AddPR_successStoriesData",
        {
          nameOfPersonConcerned: SuccessStoryData.nameOfPersonConcerned,
          successStoryDetails: SuccessStoryData.successStoryDetails,
          quotationsFromPersonConcerned:
            SuccessStoryData.quotationsFromPersonConcerned,
          pR_ReportsStagesGuid: SuccessStoryData.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateSuccessStory = createAsyncThunk(
  "ValidateSuccessStory/ValidateSuccessStory",
  async (SuccessStoryData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_successStories/ValidatePR_successStoriesListData",
        {
          nameOfPersonConcerned: SuccessStoryData.nameOfPersonConcerned,
          successStoryDetails: SuccessStoryData.successStoryDetails,
          quotationsFromPersonConcerned:
            SuccessStoryData.quotationsFromPersonConcerned,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteSuccessStory = createAsyncThunk(
  "GetSpecificRowNoteSuccessStory/GetSpecificRowNoteSuccessStory",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data.filter((item) => item.incrementNumber - 1 === 1);
      //   return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SuccessStory = createSlice({
  name: "SuccessStory",
  initialState: {
    OneSuccessStory: {},
    loadingOneSuccessStory: false,
    errorOneSuccessStory: null,

    AddSuccessStory: {},
    loadingAddSuccessStory: false,
    errorAddSuccessStory: null,

    UpdateSuccessStory: {},
    loadingUpdateSuccessStory: false,
    errorUpdateSuccessStory: null,

    DeleteSuccessStory: {},
    loadingDeleteSuccessStory: false,
    errorDeleteSuccessStory: null,

    ListSuccessStory: {},
    loadingListSuccessStory: false,
    errorListSuccessStory: null,

    SuccessStoryValidate: [],
    loadingSuccessStoryValidate: false,
    errorSuccessStoryValidate: null,

    OneSpecificRowNoteSuccessStory: {},
    loadingOneSpecificRowNoteSuccessStory: false,
    errorOneSpecificRowNoteSuccessStory: null,
  },
  reducers: {
    restValidateSuccessStory: (state, action) => {
      state.SuccessStoryValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetOneSuccessStory.pending, (state, action) => {
        state.loadingOneSuccessStory = true;
        state.OneSuccessStory = action.payload;
        state.errorOneSuccessStory = null;
      })
      .addCase(GetOneSuccessStory.fulfilled, (state, action) => {
        state.loadingOneSuccessStory = false;
        state.OneSuccessStory = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneSuccessStory.rejected, (state, action) => {
        state.loadingOneSuccessStory = false;
        state.errorOneSuccessStory = action.payload;
      })

      .addCase(DeleteSuccessStory.pending, (state, action) => {
        state.loadingDeleteSuccessStory = true;
        state.DeleteSuccessStory = action.payload;
        state.errorDeleteSuccessStory = null;
      })
      .addCase(DeleteSuccessStory.fulfilled, (state, action) => {
        state.loadingDeleteSuccessStory = false;
        state.DeleteSuccessStory = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteSuccessStory.rejected, (state, action) => {
        state.loadingDeleteSuccessStory = false;
        state.errorDeleteSuccessStory = action.payload;
      })
      .addCase(GetListSuccessStory.pending, (state, action) => {
        state.loadingListSuccessStory = true;
        state.ListSuccessStory = action.payload;
        state.errorListSuccessStory = null;
      })
      .addCase(GetListSuccessStory.fulfilled, (state, action) => {
        state.loadingListSuccessStory = false;
        state.ListSuccessStory = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListSuccessStory.rejected, (state, action) => {
        state.loadingListSuccessStory = false;
        state.errorListSuccessStory = action.payload;
      })
      .addCase(UpdateGetListSuccessStoryData.pending, (state, action) => {
        state.loadingUpdateSuccessStory = true;
        state.UpdateSuccessStory = action.payload;
        state.errorUpdateSuccessStory = null;
      })
      .addCase(UpdateGetListSuccessStoryData.fulfilled, (state, action) => {
        state.loadingUpdateSuccessStory = false;
        state.UpdateSuccessStory = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateGetListSuccessStoryData.rejected, (state, action) => {
        state.loadingUpdateSuccessStory = false;
        state.errorUpdateSuccessStory = action.payload;
      })
      .addCase(ValidateSuccessStory.pending, (state, action) => {
        state.loadingSuccessStoryValidate = true;
        state.SuccessStoryValidate = action.payload;
        state.errorSuccessStoryValidate = null;
      })
      .addCase(ValidateSuccessStory.fulfilled, (state, action) => {
        state.loadingSuccessStoryValidate = false;
        state.SuccessStoryValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateSuccessStory.rejected, (state, action) => {
        state.loadingSuccessStoryValidate = false;
        state.errorSuccessStoryValidate = action.payload;
      })
      .addCase(AddSuccessStoryData.pending, (state, action) => {
        state.loadingAddSuccessStory = true;
        state.AddSuccessStory = action.payload;
        state.errorAddSuccessStory = null;
      })
      .addCase(AddSuccessStoryData.fulfilled, (state, action) => {
        state.loadingAddSuccessStory = false;
        state.AddSuccessStory = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddSuccessStoryData.rejected, (state, action) => {
        state.loadingAddSuccessStory = false;
        state.errorAddSuccessStory = action.payload;
      })

      .addCase(GetSpecificRowNoteSuccessStory.pending, (state, action) => {
        state.loadingOneSpecificRowNoteSuccessStory = true;
        state.OneSpecificRowNoteSuccessStory = action.payload;
        state.errorOneSpecificRowNoteSuccessStory = null;
      })
      .addCase(GetSpecificRowNoteSuccessStory.fulfilled, (state, action) => {
        state.loadingOneSpecificRowNoteSuccessStory = false;
        state.OneSpecificRowNoteSuccessStory = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificRowNoteSuccessStory.rejected, (state, action) => {
        state.loadingOneSpecificRowNoteSuccessStory = false;
        state.errorOneSpecificRowNoteSuccessStory = action.payload;
      });
  },
});
export const { restValidateSuccessStory } = SuccessStory.actions;
export default SuccessStory.reducer;
